/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRegionDto } from '../../models/backend-region-dto';

export interface ProjectsRegionsList$Params {
  country?: number;

  /**
   * A search term.
   */
  search?: string;
}

export function projectsRegionsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsRegionsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendRegionDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsRegionsList.PATH, 'get');
  if (params) {
    rb.query('country', params.country, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendRegionDto>>;
    }),
  );
}

projectsRegionsList.PATH = '/api/projects/regions/';
